import React from 'react';
import Input from './input';
import DateInput from './date_input';
import Switch from './switch';
import Select from './select';
import useGym from '../../helpers/use_gym';

interface EditFormFieldProps {
  field: any;
  value: any;
  onChange: (value: any) => void;
}

const EditFormField = ({ value, onChange, field }: EditFormFieldProps) => {
  const gym = useGym();
  const type = field.field_type || field.type;

  if (type === 'text') return <Input value={value} onChange={(val) => onChange(val)} />;

  if (['number', 'weight', 'percent', 'currency'].indexOf(type) >= 0)
    return (
      <div className="flex align-center">
        {type === 'currency' && <span className="margin-right-8">{gym.currency_symbol}</span>}
        <Input type="number" value={value} onChange={(val) => onChange(val)} />
        {type === 'percent' && <span className="margin-left-8">%</span>}
        {type === 'weight' && <span className="margin-left-8">{gym.units.mass}</span>}
      </div>
    );

  if (type === 'date')
    return <DateInput value={value} onChange={(val) => onChange(val)} variant="36" />;

  if (type === 'checkbox')
    return (
      <Switch checked={value === 'true' || value === true} onChange={(val) => onChange(val)} />
    );

  if (type === 'drop_select')
    return (
      <Select value={value} options={field.params.options} onChange={(val) => onChange(val)} />
    );

  return null;
};

export default EditFormField;
